import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'
import { Estimate } from '~/_shared/models'

// State
export const state = {
  estimates: [],
  estimate: new Estimate(),
  total: 0
}

// Getters
export const getters = {
  estimates: state => state.estimates,
  estimate: state => state.estimate,
  total: state => state.total
}

// Mutations
export const mutations = {
  ESTIMATES (state, data) {
    state.estimates = data
  },

  ESTIMATE (state, data) {
    state.estimate = Object.assign(new Estimate(), data)
  },

  TOTAL (state, data) {
    state.total = data
  }
}

// Actions
export const actions = {
  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(
      laroute.route('estimates_filter', { companyAbbr: store.getters['auth/company'], ...filterData })
    )

    data.items.map((estimate) => {
      estimate.created_at = moment(estimate.created_at).format('YYYY-MM-DD')
      estimate.due_date = moment(estimate.due_date).format('YYYY-MM-DD')
    })

    commit('ESTIMATES', data.items)
    commit('TOTAL', data.total)
  },

  async fetchOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_estimate', {
      id
    }))
    commit('ESTIMATE', data)
  },

  async create ({ commit }, formData) {
    const { data } = await axios.post(laroute.route('create_estimate', { companyAbbr: store.getters['auth/company'] }), formData)
    commit('ESTIMATE', data)
  },

  async createItems ({ commit }, { id, items }) {
    await axios.patch(laroute.route('add_item_estimate', { id }), { items })
  },

  async update ({ commit }, { id, estimate, items }) {
    await axios.patch(laroute.route('update_estimate', { id }), { estimate, items })
  },

  async delete ({ commit }, { id, reason }) {
    await axios.delete(laroute.route('delete_estimate', { id }), { data: { reason } })
  },

  async deleteItem ({ commit }, { id }) {
    await axios.delete(laroute.route('delete_estimate_item', { id }))
  },

  async getCustomerEstimates ({ commit }, { customerId }) {
    await axios.get(laroute.route('get-customer-estimates',
      { companyAbbr: store.getters['auth/company'],
        customerId
      })).then((res) => {
      res.data.map((estimate) => {
        estimate.created_at = moment(estimate.created_at).format('YYYY-MM-DD')
        estimate.multiplier = 1
        estimate.is_active = true
      })
      commit('ESTIMATES', res.data)
    })
  },

  async consolidate ({ commit }, id) {
    await axios.post(laroute.route('estimate-consolidate', { companyAbbr: store.getters['auth/company'], id: id }))
      .then((res) => {
        if (res.data !== null) {
          commit('ESTIMATE', res.data)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/estimate.js